import { render, staticRenderFns } from "./BriqMultiselect.vue?vue&type=template&id=4003b4f2&scoped=true&lang=pug&"
import script from "./BriqMultiselect.vue?vue&type=script&lang=js&"
export * from "./BriqMultiselect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BriqMultiselect.vue?vue&type=style&index=1&id=4003b4f2&scoped=true&lang=stylus&"
import style2 from "./BriqMultiselect.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003b4f2",
  null
  
)

export default component.exports